import styles from './style.postcss';

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { connect, moment, testClass } from 'omni-common-ui';
import UserCard from 'components/UserCard';

class IndividualNote extends PureComponent {
  _renderNoteDate() {
    return <span className={styles.IndividualNote_footer_date}>
      {moment.utc(this.props.note.notedDateTimeUtc).local().format('YYYY-MM-DD')}
    </span>;
  }

  render() {
    return <div className={styles.IndividualNote}>
      <div className={styles.IndividualNote_header}>
        <span className={testClass('individual-note-title')}>
          {this.props.note.category}
        </span>
        <span>
          {this.props.note.noteName}
        </span>
        <span>
          <Link to={this.props.buildRoute(`/group/${this.props.note.groupId}`)}>
            {this.props.note.groupCode}
          </Link>
        </span>
      </div>
      <div className={classnames(styles.IndividualNote_content, testClass('individual-note-content'))}>
        {this.props.note.content}
      </div>
      <div className={styles.IndividualNote_footer}>
        <span>Created by:</span>
        <UserCard id={`${this.props.note.notedByUserId}`}
            className={styles.IndividualNote_footer_user}
            avatarClassName={styles.IndividualNote_footer_user_avatar} />
        {this._renderNoteDate()}
      </div>
    </div>;
  }
}

IndividualNote.propTypes = {
  note: PropTypes.object,
  buildRoute: PropTypes.func,
};

export default connect()(IndividualNote);



// WEBPACK FOOTER //
// ./containers/Student/Note/IndividualNote/index.jsx